import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import ComingSoon from './components/pages/ComingSoon';
import './styles/GlobalStyles.css';

// Toggle this flag to show/hide the Coming Soon page
const SHOW_COMING_SOON = false;

function App() {
  // If Coming Soon mode is enabled, show only the Coming Soon page
  if (SHOW_COMING_SOON) {
    return (
      <div className="App">
        <ComingSoon />
      </div>
    );
  }

  // Otherwise, show the full website
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main>
          <Home />
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
